module.exports = __webpack_public_path__ + "static/media/lung.36bbf58b.png";